// extracted by mini-css-extract-plugin
export default {"line":"activity-timeline-space_line__6s9tz","titleWrapper":"activity-timeline-space_titleWrapper__5rxWi"};